module.exports = __webpack_public_path__ + "assets/fa-regular-400.89ffa3aba80d30ee0a9371b25c968bbb.svg";